import module from 'cheques/module.js'
import template from './template.html'

class ChequesComponent {
  constructor (Cheque, ChequeEmpleados, $notify, $api) {
    this.Cheque = Cheque
    this.ChequeEmpleados = ChequeEmpleados
    this.$notify = $notify
    this.$api = $api
    this.buscando = false
  }

  $onInit () {
    this.$promise = this.Cheque.get(false, false, false)
      .then((response) => {
        this.data = response.data
        this.cheque = {}
        this.cheque.status = 't'
      })
  }

  editarCheque (cheque) {
    this.cheque = cheque
    this.buscando = true

    this.ChequeEmpleados.get(this.cheque.id_empresa)
      .then((response) => {
        this.data.empleados = response.data
        this.buscando = false
      })
  }

  limpiarForm () {
    this.cheque = {}
    this.cheque.status = 't'
  }

  cargarCuentas () {
    this.$promise = this.Cheque.get(this.cheque.id_operadora, false, false)
      .then((response) => (this.data = response.data))
  }

  cargarChequeras () {
    this.$promise = this.Cheque
      .get(this.cheque.id_operadora, this.cheque.id_cuenta, this.cheque.id_empresa)
      .then((response) => {
        this.data = response.data

        if (this.data.cheques.length) {
          this.data.cheques.map((item) => item.link = this.imprimirPDF({folio: item.folio}))
        }
      })
  }

  guardarCheque () {
    this.$promise = this.Cheque.post(this.cheque)
      .then((response) => {
        if (response.data !== true) {
          this.$notify.error(response.data)
        } else {
          this.$notify.success('Guardado.')
          this.cheque = {}
        }
      })
  }

  imprimirPDF (data) {
    const pdfParams = {}

    if (data.id_cuenta) {
      pdfParams.params = {id_cuenta: data.id_cuenta}
    } else if (data.folio) {
      pdfParams.folio = data.folio
    } else {
      alert('Ocurrió un problema inesperado.')

      return
    }

    return this.$api.link('/api/empresa/banco/cuenta/impresion', pdfParams)
  }
}

module.component('cheques', {
  controller: ChequesComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/cheques/components/component.js